export const authActionTypes = {
    LOGIN_START: "AUTH_LOGIN_START",
    LOGIN_SUCCESS: "AUTH_LOGIN_SUCCESS",
    LOGIN_ERROR: "AUTH_LOGIN_ERROR",
    LOGIN_INITIAL_CHECK: "AUTH_INITIAL_CHECK",
    LOGOUT: "LOGOUT"
};
